import ChangeDeviceModal from './ChangeDeviceModal';

export default ChangeDeviceModal;
